import { render } from "./VariableDisplayItem.vue?vue&type=template&id=59c90964&ts=true"
import script from "./VariableDisplayItem.vue?vue&type=script&lang=ts"
export * from "./VariableDisplayItem.vue?vue&type=script&lang=ts"

import "./VariableDisplayItem.vue?vue&type=style&index=0&id=59c90964&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QPopupEdit from 'quasar/src/components/popup-edit/QPopupEdit.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QToggle,QOptionGroup,QInput,QBtn,QTooltip,QSpace,QSelect,QItem,QItemSection,QMenu,QSeparator,QBtnToggle,QCheckbox,QPopupEdit});qInstall(script, 'directives', {ClosePopup});
